var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['menu', _vm.getMobile ? 'menu-burger__container' : '', _vm.getRouteLeave && !_vm.getMobile ? 'menu--leave' : ''],
    on: {
      "mouseleave": _vm.resetHover
    }
  }, [(!_vm.getMobile) ? _c('ul', {
    staticClass: "niv-1"
  }, _vm._l((_vm.getMenuData.body.items), function(item, i) {
    return _c('li', {
      key: "item",
      staticClass: "li-niv-1",
      class: [_vm.niv1Path === i + 1 ? 'active' : '', _vm.isHome && _vm.niv1Target === i + 1 ? 'active' : '', _vm.isHome && !_vm.niv1Target ? 'default' : '', _vm.getPostCategory === item.object_slug ? 'active' : ''],
      attrs: {
        "data-index": i + 1
      },
      on: {
        "mouseover": _vm.setHover
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.object_slug))
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('ul', {
      staticClass: "niv-2"
    }, _vm._l((item.children), function(subitem) {
      return _c('li', {
        key: "sub-item"
      }, [_c('router-link', {
        attrs: {
          "to": ("/" + (subitem.object_slug))
        }
      }, [_vm._v(_vm._s(subitem.title))])], 1)
    }))], 1)
  })) : _c('div', {
    class: ['burger-menu', _vm.menuOpen ? 'burger-menu--opened' : 'burger-menu--closed', _vm.getRouteLeave ? 'burger-menu--leave' : ''],
    on: {
      "click": _vm.setMenuState
    }
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7078c0f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/common/header/Menu.vue
// module id = Npiu
// module chunks = 1